exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section.pricing-section .rate-bubble-wrapper{padding:25px 0}.section.pricing-section .rate-bubble-wrapper .rate-bubble-container{width:150px}", ""]);

// exports
